import type { InputTextBoxProps } from '..'
import type { Tokens } from '../../../theming/types'

export default (config: {
  props: Partial<InputTextBoxProps>
  tokens: Tokens
}) => {
  const { props } = config

  return {
    default: {
      wrapper: {
        maxHeight: '28px',
      },

      input: {
        paddingTop: '4px',
        paddingBottom: '5px',
        paddingInlineStart: props?.startElement ? 0 : '8px',
        paddingInlineEnd: props?.endElement ? 0 : '8px',

        '&:disabled': {
          WebkitTextFillColor: '#999999',
        },

        '&:read-only': {
          color: '#999999',
        },
      },
    },

    readOnly: {
      wrapper: {
        borderColor: '#e9e9e9',
      },
    },
  } as const
}
